var quizQuestions = [
  {
    question: "How many points do you receive for driving 1-15 mph over the speed limit?",
    answers: {
      a: "1 point",
      b: "2 points",
      c: "3 points",
      d: "4 points"
    },
    description: "If you are caught going 1-15 mph over the speed limit, you will receive <strong>two points</strong> on your driver's license. If you are caught going 16-25 over, it's 4 points, and anything faster than that is 6 points.",
    correctAnswer: "b"
  },
  {
    question: "You cannot be cited for keeping your headlights off at night.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "Failing to turn on your headlights can result in a traffic citation worth 2 points.",
    correctAnswer: "b"
  },
  {
    question: "Red signs require drivers to:",
    answers: {
      a: "Stop",
      b: "Take immediate action",
      c: "Avoid upcoming hazards",
      d: "Turn around"
    },
    description: "Signs in red will always require a driver to take an <strong>immediate action</strong>, like stopping or turning around.",
    correctAnswer: "b"
  },
  {
    question: "When a road sign is green, it generally provides the driver with what information?",
    answers: {
      a: "A regulation",
      b: "Direction guidance",
      c: "A general warning",
      d: "Scenic guidance"
    },
    description: "Green signs usually indicate permitted movements and <strong>directional guidance</strong>. Brown signs, on the other hand, give motorists public recreation information and scenic guidance.",
    correctAnswer: "b"
  },
  {
    question: "A pennant-shaped sign is usually used for:",
    answers: {
      a: "General regulatory signs",
      b: "School crossing signs",
      c: "Advanced warning for no pass zones",
      d: "To warn of possible hazards on or near the road"
    },
    description: "Usually a pennant-shaped sign will indicate to motorists that a <strong>no pass zone is up ahead</strong>. Regulatory signs are vertical rectangles; pentagons are for school crossings and school advance signs; and diamond-shaped signs warn motorists of possible hazards.",
    correctAnswer: "c"
  },
  {
    question: "What does this sign mean?<br /><img src=\"/images/quiz/quiz6.jpg\" alt=\"Orange Triangle Sign\" />",
    answers: {
      a: "It alerts the driver about a nearing construction zone",
      b: "It is warning of an approaching hazard on the road",
      c: "It's for vehicles that drive less than 25 mph",
      d: "It's for cars with an impaired person behind-the-wheel"
    },
    description: "If a <strong>vehicle that cannot drive above 25 mph is on a public road</strong>, it must display this symbol on its rear.",
    correctAnswer: "c"
  },
  {
    question: "If an arrow light is flashing yellow, you must come to a complete stop and wait for it to turn green.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "A flashing yellow arrow light means you must yield to oncoming traffic, but, if it is safe to do so, <strong>you may turn</strong>. If the arrow light is a steady yellow, the light is about to turn red. If the arrow light is red, you are not allowed to turn.",
    correctAnswer: "b"
  },
  {
    question: "You can pass on a road with a solid yellow line.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "<strong>You cannot pass when a road line is solid</strong>. Rather, you may only pass if the line is striped.",
    correctAnswer: "b"
  },
  {
    question: "When you pass another car, you must return to the right side of the road at least 100 feet before an oncoming vehicle.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "If you are on a road where you are allowed to pass, you must be able to return to your lane before any approaching traffic is within <strong>100 feet</strong> of your car. If you cannot make it in time, do not attempt the pass.",
    correctAnswer: "a"
  },
  {
    question: "You can pass within 100 feet of an intersection.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "<strong>You may not pass within 100 feet of an intersection</strong>, railroad crossing, bridge, viaduct or tunnel.",
    correctAnswer: "b"
  },
  {
    question: "To hand signal a left turn, you must stick your arm straight out.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "<strong>To signal left, you stick your arm straight out</strong>; to signal right, you stick your arm up, keeping your elbow straight; to signal a stop, you point your arm down.",
    correctAnswer: "a"
  },
  {
    question: "You must drive in a clockwise direction in a roundabout.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "Roundabouts always travel in a <strong>counter-clockwise</strong> direction.",
    correctAnswer: "b"
  },
  {
    question: "If a car is traveling 55 mph, how may feet does it travel in a second?",
    answers: {
      a: "60.7 feet",
      b: "70.7 feet",
      c: "80.7 feet",
      d: "90.7 feet"
    },
    description: "A car going 55 mph can travel <strong>80.7 feet</strong> per second. To put that in perspective, a car traveling at 55 mph can travel a football field in about 3.7 seconds.",
    correctAnswer: "c"
  },
  {
    question: "Drivers age 16-29 account for what percentage of fatigue-related accidents?",
    answers: {
      a: "61%",
      b: "62%",
      c: "63%",
      d: "64%"
    },
    description: "According to the Indiana Driver Handbook, <strong>64%</strong> of all fatigue-related accidents involved drivers between the ages of 16 to 29.",
    correctAnswer: "d"
  },
  {
    question: "Going 20 hours without sleep impairs a driver's judgement to the same extent as having a .08 BAC does.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "It only takes staying awake for <strong>18 hours</strong> straight before a driver's judgment becomes so impaired it matches that of someone with a .08 BAC.",
    correctAnswer: "b"
  },
  {
    question: "When should your headlights be on?",
    answers: {
      a: "After sunset",
      b: "When visibility is less than 500 feet",
      c: "Before sunrise",
      d: "All of the above"
    },
    description: "You must use your headlights <strong>between sunset and sunrise</strong> and when <strong>visibility is less than 500 feet</strong>.",
    correctAnswer: "d"
  },
  {
    question: "Failing to stop for a school bus can result in a fine of $550.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "A Class B Misdemeanor, failing to stop for a school bus can result in a <strong>$1,000 fine</strong> and up to 180 days in jail.",
    correctAnswer: "b"
  },
  {
    question: "Where is it illegal to park?",
    answers: {
      a: "On a highway",
      b: "Adjacent to a yellow curb",
      c: "On a side walk",
      d: "All of the above"
    },
    description: "<strong>It is illegal to park on a highway, next to a yellow curb and on a side walk</strong>.",
    correctAnswer: "d"
  },
  {
    question: "If you are driving at 50 mph or above, how soon should you turn on your blinker?",
    answers: {
      a: "200 feet away from the turn",
      b: "300 feet away from the turn",
      c: "400 feet away from the turn",
      d: "500 feet away from the turn"
    },
    description: "In order for any drivers behind you to have enough time to react, you should signal your intention to turn at least <strong>300 feet</strong> before making the turn.",
    correctAnswer: "b"
  },
  {
    question: "What kind of information do diamond-shaped signs usually provide drivers?",
    answers: {
      a: "Directional information",
      b: "School zones",
      c: "Recreational information",
      d: "Warnings"
    },
    description: "A sign shaped like a diamond will provide drivers with some kind of <strong>warning</strong>, usually of approaching hazards and road conditions.",
    correctAnswer: "d"
  }
];
